/**
 * Validates if a string is a valid hex color code
 * @param {string} color - The color string to validate
 * @returns {boolean} - True if the color is a valid hex code
 */
export const isValidHexColor = color => {
  // Check if color is a valid hex color code (3 or 6 digits)
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color);
};
